export const FONT = "inter, 'Helvetica Neue', sans-serif";
